import { Table } from "antd";
import axios, { formToJSON } from "axios";
import { AppConstants, CustomHeaderToken, GetWebServiceUrl } from "../utils/constants";
import { useCookies } from "react-cookie";
import NotificationHeader, { SetNotificationWithoutDismiss } from "../utils/notification";
import { useEffect, useState } from "react";


async function fetchData(cache) {
    console.log("fetchData")

    let response = await axios.get(GetWebServiceUrl(AppConstants.USER_LIST), CustomHeaderToken(cache.access_token)).catch(err => {
        console.log("ERR", err)
        SetNotificationWithoutDismiss("Error", err.response.status + "\n" + JSON.stringify(err.response.data.message), "danger");
    })

    return response;
}


const columns = [
    {
        title: 'ID',
        dataIndex: 'ID',
        key: 'ID',
    },
    {
        title: 'تاریخ ایجاد',
        dataIndex: 'CreatedAt',
        key: 'CreatedAt',
    },
    {
        title: 'نام',
        dataIndex: 'username',
        key: 'uesrname',
    },
    {
        title: 'ایمیل',
        dataIndex: 'email',
        key: 'email',
        render: (value)=>(
            <a href={"mailto:"+value} target="_blank">{value}</a>
        )
    },
    {
        title: 'زمان شروع',
        dataIndex: 'start_date',
        key: 'start_date',
    },
    {
        title: 'زمان آپلود',
        dataIndex: 'upload_date',
        key: 'upload_date',
    },
    {
        title: 'کندو',
        dataIndex: 'cando_link',
        key: 'cando_link',
        render: (value)=>(
            <a href={value} target="_blank">{value}</a>
        )
    },
    {
        title: 'لینک سوال',
        dataIndex: 'link',
        key: 'link',
        render: (value)=>(
            <a href={value} target="_blank">{value}</a>
        )
    },
    {
        title: 'لینک پروژه',
        dataIndex: 'project_link',
        key: 'project_link',
        render: (value)=>(
            <a href={value} target="_blank">{value}</a>
        )
    },
];



export default function UsersContent() {
    const [cookies, setCookie] = useCookies(['access_token'])
    const [dataSource, setDataSource] = useState([])

    useEffect(() => {
        let response = fetchData(cookies).then(res => {
            setDataSource(res.data)
        })
    }, [])

    return (
        <>
            <NotificationHeader></NotificationHeader>
            <div>
                <Table dataSource={dataSource} columns={columns} />
            </div>
        </>
    )
}